import { Component, Input, OnInit } from '@angular/core';
import { PortalGlobals } from '../../../../app/portalglobals';
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway';

@Component({
	selector: 'EnrollmentLayout',
	template: `
		<div class="row">
			<div class="col-24">
				<router-outlet></router-outlet>
			</div>
		</div>
	`,
})
export class EnrollmentLayoutComponent implements OnInit {
	public portalGlobals: PortalGlobals;

	constructor(private _networkUserAccessGateway: UserAccessGateway, public _global: PortalGlobals) {}

	ngOnInit() {
		console.log(this._global);
		console.log(sessionStorage.getItem('PLANYEAR'));
	}
}
